import {OperationStateTypesEnum} from 'presentation/constants';
import {useState} from 'react';
import {useGetHealthRequestSchedulePermissionMutation} from '../../mutations/useGetHealthRequestSchedulePermissionMutation';
import {HandleGetHealthRequestSchedulePermissionProps} from './types';

export function useRequestSchedulePermission() {
	const {mutateAsync: getHealthRequestSchedulePermissionMutation} =
		useGetHealthRequestSchedulePermissionMutation();
	const [operationState, setOperationState] = useState<OperationStateTypesEnum>(
		OperationStateTypesEnum.NONE,
	);
	const [healthRequestSchedulePermissionState, setHealthRequestSchedulePermissionState] =
		useState({
			allowsRegistration: false,
			requestAlreadyExists: false,
			requestCity: '',
		});

	const requestSchedulePermissionIsLoading =
		operationState === OperationStateTypesEnum.SUBMITTING;

	const requestSchedulePermissionIsDone = operationState === OperationStateTypesEnum.DONE;

	const resetHealthRequestScheduleState = () => {
		setHealthRequestSchedulePermissionState({
			allowsRegistration: false,
			requestAlreadyExists: false,
			requestCity: '',
		});
		setOperationState(OperationStateTypesEnum.NONE);
	};

	const handleGetHealthRequestSchedulePermission = async ({
		city,
		specialtyCode,
		typeLocalName,
		stateCode,
		signal,
	}: HandleGetHealthRequestSchedulePermissionProps) => {
		try {
			setOperationState(OperationStateTypesEnum.SUBMITTING);
			const {permiteRegistro, jaExisteSolicitacao, nmMunicipio} =
				await getHealthRequestSchedulePermissionMutation({
					unitFedaration: stateCode,
					specialtyCode,
					typeLocalName,
					location: city,
					signal,
				});

			setHealthRequestSchedulePermissionState({
				allowsRegistration: permiteRegistro,
				requestAlreadyExists: jaExisteSolicitacao,
				requestCity: nmMunicipio,
			});

			setOperationState(OperationStateTypesEnum.DONE);
		} catch (error) {
			setOperationState(OperationStateTypesEnum.DONE);
			resetHealthRequestScheduleState();
		}
	};

	return {
		handleGetHealthRequestSchedulePermission,
		healthRequestSchedulePermissionState,
		resetHealthRequestScheduleState,
		requestSchedulePermissionIsLoading,
		requestSchedulePermissionIsDone,
	};
}
